import React, { useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from '../../Components/Reusable/CustomTextArea';
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { toast } from "react-toastify";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import SubAdminService from "../../Services/SubAdmin";

const AddSubAdmin = () => {
    const location = useLocation();
    const SubAdminData = location.state || null;
    const [subAdminEdit, setSubAdminEdit] = useState({ ...useLocation().state });
    const [data, setData] = useState([]);
    const [resetRolefield, setResetRoleField] = useState(false)
    const [rolefield, setRoleField] = useState('')


    const navigate = useNavigate();

    const Validations = yup.object().shape({
        name: validationRegex.required,
        email: validationRegex.email,
        role: validationRegex.required,
        mobile: validationRegex.mobile,

    });

    const {
        register: register,
        handleSubmit: handleSubmit,
        setValue: setValues,
        formState: { errors: errors },
        getValues: getValues,
        reset: reset,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            name: subAdminEdit?.name || "",
            email: subAdminEdit?.email || "",
            role: subAdminEdit?.role_id || "",
            mobile: subAdminEdit?.mobileNumber || "",
        },
    });


    const getAllRoleList = async () => {
        try {
            const response = await SubAdminService.getAllRolesWithoutPagination();
            setData(response.data);

        } catch (error) {
            handleApiErrors(error);
        }
    };
    useEffect(() => {
        getAllRoleList();
    }, [rolefield]);

    const onSubmit = async (data) => {
        console.log(data, 'data');
        try {
            const response = await SubAdminService.addSubAdmin({
                admin_id: subAdminEdit.admin_id || "",
                name: data.name || rolefield,
                email: data.email,
                role_id: data.role,
                mobileNumber: data.mobile,
            });
            toast.success(response.message);
            reset();
            setResetRoleField(subAdminEdit.admin_id ? false : true)
            navigate(RoutesPath.subadminlist)
        } catch (error) {
            handleApiErrors(error);
            toast.error("Failed to add Sub Admin. Please try again later.");
        }
    };

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 mb-0">SUB ADMIN </h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0"> {`${!subAdminEdit?.admin_id ? "Add" : "Edit"}`}{" "}
                        Sub Admin</h4>
                </div>
            </div>

            <div className="table_container" style={{ display: "block" }}>
                <div className="table_title">
                    <div className="table_headings">
                        <h1 className="black fs-18 fw-600 mb-0">
                            {`${!subAdminEdit?.admin_id ? "Add" : "Edit"}`}{" "}
                            Sub Admin
                        </h1>
                    </div>
                    <form>

                        <div className="row profile_inputs w-100 mt-5">

                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Name"
                                    placeholder="Name"
                                    name="name"
                                    id="name"
                                    InputType={InputType.text}
                                    showMandatory={true}
                                    setValue={setValues}
                                    register={register}
                                    additionalClasses="profile_edit"
                                    showError={errors?.name}
                                    errorMessage={errors?.name?.message}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Email ID"
                                    placeholder="email"
                                    id="email"
                                    name="email"
                                    InputType={InputType.email}
                                    showMandatory={true}
                                    additionalClasses="profile_edit"
                                    setValue={setValues}
                                    register={register}
                                    showError={errors?.email}
                                    errorMessage={errors?.email?.message}

                                />
                            </div>
                            <div className="col-md-6">
                                <CustomDropDown
                                    labelTitle="Role"
                                    placeholder="Select"
                                    name="role"
                                    id="role"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    resetValue={resetRolefield}
                                    setResetValue={setResetRoleField}
                                    showMandatory={true}
                                    setValue={setValues}
                                    showError={errors?.role}
                                    errorMessage={errors?.role?.message}
                                    onChange={(e) => {
                                        setRoleField(e.value);
                                    }}
                                    options={
                                        data?.map((e) => { return { value: e.role_id, label: e.roleName } })
                                    }
                                    defaultOption={() => {
                                        return subAdminEdit.admin_id ? { value: subAdminEdit.role_id, label: subAdminEdit.roleName } : null
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <CustomTextField
                                    labelTitle="Mobile No."
                                    placeholder="Enter Mobile No."
                                    name="mobile"
                                    id="mobile"
                                    InputType={InputType.number}
                                    showMandatory={true}
                                    setValue={setValues}
                                    register={register}
                                    additionalClasses="profile_edit"
                                    showError={errors?.mobile}
                                    errorMessage={errors?.mobile?.message}
                                />
                            </div>
                            <div className="d-flex justify-content-end">
                                <ButtonWithIcon
                                   text={subAdminEdit?.admin_id ? "Update" : "Submit"}
                                    icon={SvgImages.tick_mark}
                                    onClick={handleSubmit(onSubmit)}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddSubAdmin;
